import { tw } from 'twind/css';

import { useTranslate } from 'hooks/useTranslations';
import { Size } from '__generated__/graphql';

export type StockMessageProps = {
  className?: string;
  quantity: number | undefined;
  selectedSize: Size | undefined;
};

const STOCK_THRESHOLDS = {
  veryLow: 5,
  low: 10,
};

const StockMessageText = ({ quantity }) => {
  const t = useTranslate();
  let text = t('inStock');

  if (quantity === 0) {
    text = t('outOfStock');
  } else if (quantity <= STOCK_THRESHOLDS.veryLow) {
    text = t('lowStockQuantity', { quantity });
  } else if (
    quantity > STOCK_THRESHOLDS.veryLow &&
    quantity <= STOCK_THRESHOLDS.low
  ) {
    text = t('lowStock');
  }

  return <span>{text}</span>;
};

export const StockMessage = ({
  className,
  quantity,
  selectedSize,
}: StockMessageProps) => {
  // Return null:
  //   - If quantity is undefined (it hasn't been retrieved yet) & size is orderable.
  //   - If selectedSize is undefined, no size has been chosen.
  //   - If selectedSize.orderable is undefined, stock status is unknown.
  if (!selectedSize || selectedSize.orderable === undefined) return null;
  if (quantity === undefined && selectedSize.orderable) return null;

  let productQuantity = 0; // default to 0
  if (quantity) productQuantity = quantity;

  return (
    <p
      data-test-id="low-inventory-message"
      className={tw(['text-xs uppercase flex font-bold', className])}
    >
      <StockMessageText quantity={productQuantity} />
    </p>
  );
};
